/* global firebase */
import { SET_UPLOAD_PROGRESS } from "../types";
import { storageRef, storage, db } from "../../firebase/firebase";
import store from "../store";
import _ from 'lodash';

export const downloadStorageFile = (fileStorageUrl) => {
    let gsReference = storage.refFromURL(fileStorageUrl);
    gsReference.getDownloadURL().then(function (url) {
        var element = document.createElement("a");
        element.href = url;
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    });
}

// Upload a single file and return its download URL
export const uploadFile = (storagePath, file, dispatch) => {
    let uploader = new Uploader(dispatch);
    return uploader.uploadFiles([{ file, storagePath }]).then(snapshots => {
        return snapshots[0].ref.getDownloadURL();
    })
};

export const Uploader = function (dispatch) {
    this.dispatch = dispatch;
    this.uploadData = {};
    this.totalUploadSize = 0;
    this.totalBytesTransferred = 0;
    this.startDownloadTime = new Date();

    // uploadFiles: [{file, storagePath}]
    this.uploadFiles = function (uploadFiles) {
        this.startDownloadTime = new Date();

        let promises = [];
        for (let i = 0; i < uploadFiles.length; i++) {
            let file = uploadFiles[i].file;
            let storagePath = uploadFiles[i].storagePath;
            this.totalUploadSize += file.size;
            this.uploadData[storagePath] = { file, storagePath, bytesTransferred: 0 };
            const uploadTask = storageRef.child(storagePath).put(file);
            uploadTask.on("state_changed", snapshot => {
                this.uploadData[storagePath].bytesTransferred = snapshot.bytesTransferred;
                this.updateProgress(snapshot);
            }, error => { console.error(error) });
            promises.push(uploadTask);
        }
        return Promise.all(promises);
    }

    this.updateProgress = function () {
        this.updateTotalBytesTransferred();
        this.updateEstimatedTimeLeft();

        var progress = (this.totalBytesTransferred / this.totalUploadSize) * 100;
        dispatch({
            type: SET_UPLOAD_PROGRESS,
            payload: {
                progress,
                numFiles: Object.entries(this.uploadData).length,
                bytesTransferred: this.totalBytesTransferred,
                uploadSize: this.totalUploadSize,
                estimatedTimeLeft: this.estimatedTimeLeft
            }
        });
    }

    this.updateTotalBytesTransferred = function () {
        this.totalBytesTransferred = 0;
        let uploadDataEntries = Object.entries(this.uploadData);
        for (let [key, data] of uploadDataEntries) {
            this.totalBytesTransferred += data.bytesTransferred;
        }
        return this.totalBytesTransferred;
    }

    this.updateEstimatedTimeLeft = function () {
        let now = new Date();
        let secondsSinceDownloadStart = Math.abs(now - this.startDownloadTime) / 1000;
        let bytesPerSecond = this.totalBytesTransferred / secondsSinceDownloadStart;
        let bytesLeft = this.totalUploadSize - this.totalBytesTransferred;
        this.estimatedTimeLeft = bytesLeft / bytesPerSecond;
        return this.estimatedTimeLeft;
    }
}

export const restApiNoAuth = (functionName, payload) =>
    fetch(
        `https://us-central1-${firebase.app().options.projectId}.cloudfunctions.net/${functionName}`, // or we could allow the functions to look locally: `/${functionName}`. Local emulators will need some more permissions for this to work. See https://firebase.google.com/docs/functions/local-emulator.
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ data: { ...payload } })
        }
    );

function fileSafeName(str) {
    if (!str) {
        return 'null';
    }
    return str.replace(/[^a-z0-9\-\.]/gi, '-');
}

export const getCurrentUserOrganizationRef = () => store.getState().user.user.organizationRef;
export const userOrganizationHasFeatureFlag = (featureFlag) => {
    let orgId = _.get(store.getState(), 'user.user.organizationRef.id');
    if (orgId) return !!_.get(store.getState(), `data.organizations.${orgId}.featureFlags.${featureFlag}`);
    return false;
};
export const getCurrentUser = () => store.getState().user.user;
export const currentUserIsRole = (role) => store.getState().user.user.role === role;
export const getOrganizationRef = organizationKey => db.doc("organizations/" + organizationKey);
export const unixTimestamp = () => Math.round(new Date().getTime() / 1000);
export const getIconStoragePath = packageName => `organizations/${getCurrentUserOrganizationRef().id}/apps/${packageName}/icons/icon_${unixTimestamp()}.png`;
export const getObbStoragePath = (appData) => `organizations/${getCurrentUserOrganizationRef().id}/apps/${appData.packageName}/obbs/${unixTimestamp()}_${appData.latestVersion}+${fileSafeName(appData.versionName)}.obb`;
export const getApkStoragePath = (appData) => `organizations/${getCurrentUserOrganizationRef().id}/apps/${appData.packageName}/apks/${unixTimestamp()}_${appData.latestVersion}+${fileSafeName(appData.versionName)}.apk`;
export const getStagingStoragePath = (fileName) => `organizations/${getCurrentUserOrganizationRef().id}/staging/${unixTimestamp()}_${fileName}`;
export const toGSBucketPath = (path) => `gs://${storageRef.bucket}/${path}`;
export const serverTimestamp = () => firebase.firestore.FieldValue.serverTimestamp();